<template>
    <div class="m-scrollable" data-scrollable="true" data-height="680" data-mobile-height="600">
        <!--Begin::Timeline 2 -->
        <div class="m-timeline-2">
            <div class="m-timeline-2__items  m--padding-top-25 m--padding-bottom-30">
                <div class="m-timeline-2__item m--margin-bottom-50" v-for="timeline in timelineArr">
                    <span class="m-timeline-2__item-time">{{ timeline.date }}<br /><span class="small">{{ timeline.time }} Uhr<br />KW{{ timeline.kw }}</span></span>
                    <div class="m-timeline-2__item-cricle">
                        <i class="fa fa-genderless" :class="timeline.cssClass"></i>
                    </div>
                    <div class="m-timeline-2__item-text  m--padding-top-5">
                        <div class="mb-2"><span class="m--font-bold" :class="timeline.cssClassHeadline">{{ timeline.title }}</span> <span v-if="timeline.title2 != ''">{{ timeline.title2 }}</span></div>
                        <div v-if="timeline.type == 1" class="row">
                            <div class="col-3">KW Umsetzung: {{ timeline.typeArr.kw }}</div>
                            <div class="col-3">Bilder: {{ timeline.typeArr.images }}</div>
                        </div>
                        <div v-if="timeline.type == 2" class="row">
                            <div class="col-3">Bilder: {{ timeline.typeArr.images }}</div>
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <!--End::Timeline 2 -->
    </div>
</template>

<script>

    export default {
        name: 'timeline',
        props: {
            timelineArr: Object
        },
    }
</script>
